// extracted by mini-css-extract-plugin
export default {"translation-preferred-form-toggle-input":"translation-preferred-form-toggle-input--vxp2V","translationPreferredFormToggleInput":"translation-preferred-form-toggle-input--vxp2V"};